module.exports = __webpack_public_path__ + "static/eating-on-board.fac804b9.jpg";